import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import includes from "lodash/includes";
import PropTypes from "prop-types";
import { totalDealsSelector } from "selectors/deal";
import { selectedPortfoliosSelector } from "selectors/portfolio";

import { LimitationsContext } from "utils/Authenticated";
import { createUrlParams } from "utils/urlParams";

const NoMatch = ({ redirectTo, selectedPortfolioIDs, selectedPortfolios }) => {
  if (!selectedPortfolios.length) return null;
  const portfolioIDs = createUrlParams({ portfolioIDs: selectedPortfolioIDs });

  return (
    <LimitationsContext.Consumer>
      {(limitations) => {
        if (
          (redirectTo === "assets" && !includes(limitations, "assets")) ||
          includes(limitations, "deals")
        ) {
          return <Redirect to={`/assets${portfolioIDs}`} />;
        }

        return <Redirect to={`/deals${portfolioIDs}`} />;
      }}
    </LimitationsContext.Consumer>
  );
};

NoMatch.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  selectedPortfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  selectedPortfolioIDs: PropTypes.arrayOf(PropTypes.number),
  redirectTo: PropTypes.oneOf(["assets", "deals"]),
};

const mapStateToProps = (state) => ({
  isLoading: state.loading.portfolios,
  redirectTo: totalDealsSelector(state) > 0 ? "deals" : "assets",
  selectedPortfolios: selectedPortfoliosSelector(state),
  selectedPortfolioIDs: state.selectedPortfolioIDs,
});

export default connect(mapStateToProps)(NoMatch);
